module.exports = __webpack_public_path__ + "static/media/Agri-Entrepreneur Infographic Desktop 19-12-2023  1.ce156544.gif";